//node modules
import React, { useState } from "react";

//hooks & functions
//components
import { Button } from "reactstrap";
import { Auth } from "../../firebase/firebase";

//validators

type props = {};

const SignOutUser: React.FC<props> = () => {
  const [hover, setHover] = useState(false);
  return (
    <>
      <div className={"signout-user-wrap"}>
        <Button
          className={"signout-user-btn"}
          color={hover ? "danger" : "white"}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onClick={() => {
            Auth.signOut().then(() => {
              window.location.pathname = "/";
            });
          }}>
          Logg ut
        </Button>
      </div>
    </>
  );
};

export default SignOutUser;
